import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import CardHeader from '@material-ui/core/CardHeader';
import LinearProgress from '@material-ui/core/LinearProgress';

import ProfileForm from '../ProfileForm';

const useStyles = makeStyles({
  root: {
    maxWidth: 300,
    marginTop: 20
  },
  pos: {
    marginBottom: 12,
  },
});

export default function ChatIntroCard(props) {
  const classes = useStyles();

  return (
    <Card className={classes.root}>
      { props.inProgress ? <LinearProgress /> : '' }
      <CardHeader titleTypographyProps={{variant: 'h6', color: 'textSecondary'}}  title="Please introduce yourself">
      </CardHeader>
      <CardContent>
        <ProfileForm onSubmit={props.submitProfileForm} {...props} />
      </CardContent>
      { props.inProgress ? <LinearProgress /> : '' }
    </Card>
  );
}
